import * as Tabs from '@radix-ui/react-tabs';

import { SectionWrapper } from '../../components/SectionWrapper';
import { sessions } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';
import { KaiCoachTranscript } from './KaiCoachTranscript';

import styles from './KaiCoachSessionsSection.module.css';

export function KaiCoachSessionsSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-sessions-title"
      background="white"
      className={styles.root}
      data-testid="kai-coach-section-sessions"
      id="session"
    >
      <KaiCoachSectionHead
        id="kai-coach-sessions-title"
        kicker="See it work"
        title={
          <>
            Watch it coach, <em>one question at a time.</em>
          </>
        }
      />
      <Tabs.Root defaultValue={sessions[0].id}>
        <Tabs.List aria-label="Example sessions" className={styles.tabList}>
          {sessions.map((session) => (
            <Tabs.Trigger className={styles.tab} key={session.id} value={session.id}>
              <span className={styles.tabTitle}>{session.tab}</span>
              <span className={styles.tabSubtitle}>{session.subtitle}</span>
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {sessions.map((session) => (
          <Tabs.Content className={styles.panel} key={session.id} value={session.id}>
            <KaiCoachTranscript session={session} />
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </SectionWrapper>
  );
}
